var FakeCation = window.FakeCation || {};

(function (fc) {
  "use strict";

  const NAME = 'create';
  var pageManager = fc.pageManager;

  var page = pageManager.Page.create(NAME, '/' + NAME, '#' + NAME);

  page.html = `
<h1>${NAME}</h1>
<input type="file" accept="image/*" capture="camera">
<a href="/process">process</a>`;

  if (fc.utils.webRTCSupported) {
    pageManager.add(page);
  };

}(FakeCation));
